module.exports = __webpack_public_path__ + "img/sub.50eaebdd.png";